import React from 'react';
import { useRouter } from 'next/router';
import PageTopButton from '@components/common/pageTopButton';
import JobPostModalWrap from '@components/common/jobPostModal/JobPostModalWrap';
import Title from '@components/position/jd/title';
import CompanyImage from '@components/position/jd/companyImage';
import CompanyInfo from '@components/position/jd/companyInfo';
import Contents from '@components/position/jd/contents';
import Welfare from '@components/position/jd/welfare';
import Map from '@components/position/jd/map';
import Apply from '@components/position/jd/apply';
import PositionJob from '@components/position/jd/positionJob';
import PositionCompany from '@components/position/jd/positionCompany';
import PositionChallenge from '@components/position/jd/positionChallenge';
import NoticeBanner from '@components/position/jd/noticeBanner';
import JobPostingButton from '@components/position/jd/jobPostingButton';
import ChallengeButton from '@components/position/jd/challengeButton';
import InfoChallenge from '@components/position/jd/companyInfo/infoList/infoChallenge';
import { useJD } from '@repository/position/usePosition';
import EmptyPage from '@components/company/sn/emptyPage';
import CompanyChannel from './companyChannel';
import { PositionApplyEnum } from '@domain/constant/PositionApplyType';

import { isPrServer, isQaServer } from '@utils/common';
import classnames from 'classnames/bind';
import styles from './jd.module.scss';
const cx = classnames.bind(styles);

const JD = () => {
  const { query } = useRouter();
  const positionSn = Number(query.sn);
  const { data: positionDetail, isFetched } = useJD(positionSn);

  if (!isFetched) return null;

  if (!positionDetail) {
    return <EmptyPage type="NOT_EXIST_COMPANY" />;
  }

  const {
    basicInfo: { applyType },
    additionalInfo: { challenge },
    companyInfo: { companyName, companySn },
  } = positionDetail;

  const isWinBackPosition =
    (isPrServer && [91749, 91931, 91932].includes(companySn)) || (isQaServer && companySn === 91161);
  const visibleChallenge = challenge && challenge.challengeStatus === 'PROGRESS';
  const isATSPosition = PositionApplyEnum.ATS === applyType;

  return (
    <JobPostModalWrap>
      <div className={cx('wrap')}>
        {/* [D] 타이틀 영역 */}
        <Title positionDetail={positionDetail} isWinBackPosition={isWinBackPosition} />

        <div className={cx('inner')}>
          <div className={cx('infoArea')}>
            {/*챌린지 버튼*/}
            <ChallengeButton positionDetail={positionDetail} />

            {/*채용 공고 버튼*/}
            <JobPostingButton positionDetail={positionDetail} />

            {/* 기업 채널 영역 */}
            {!isWinBackPosition && <CompanyChannel positionSn={positionSn} positionDetail={positionDetail} />}

            {/* [D] 회사 정보 영역 */}
            {!isWinBackPosition && <CompanyInfo positionDetail={positionDetail} />}

            {/* [D] 챌린지 지원 정보 배너 */}
            <InfoChallenge positionDetail={positionDetail} />

            {/*채용 공고 정보 배너*/}
            {/* TODO ATS 다중 공고 생기면 복수 지원 내용 출력 */}
            {/*<InfoJobPosting positionDetail={positionDetail} />*/}

            {/* [D] ATS, Jobflex 에디터 영역 */}
            <Contents positionDetail={positionDetail} />

            {/* [D] 회사 이미지 영역 */}
            {isATSPosition && <CompanyImage positionDetail={positionDetail} />}

            {/* [D] 복지 영역 */}
            <Welfare positionSn={positionSn} positionDetail={positionDetail} />

            {/* [D] 지도 영역 */}
            <Map positionDetail={positionDetail} />
          </div>

          {/* [D] 지원 영역 */}
          <Apply positionSn={positionSn} positionDetail={positionDetail} />
        </div>

        <div className={cx('positionArea')}>
          <NoticeBanner companyName={companyName} applyType={applyType} />
          {!visibleChallenge ? (
            <>
              {/* [D] 비슷한 포지션 영역 */}
              <PositionJob />

              {/* [D] 채용중인 포지션 영역 */}
              <PositionCompany positionDetail={positionDetail} />
            </>
          ) : (
            // [D] 동일한 챌린지 포지션 영역
            <PositionChallenge positionDetail={positionDetail} />
          )}
        </div>
        <PageTopButton />
      </div>
    </JobPostModalWrap>
  );
};

export default JD;
